var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMotorYacht(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.065 30.515l1.4-2.807a1.935 1.935 0 011.731-1.072h12.352l-4.83-3.227a3.866 3.866 0 00-2.148-.651H28.34a3.869 3.869 0 00-3.283 1.823l-3.702 5.934m30 3.879v3.879m-4.839-3.879v3.879m-4.839-3.879v3.879m-24.193-3.879v3.879m-4.839-3.879v3.879m-3.87-3.879h16.45l-1.132 2.27a2.903 2.903 0 01-2.597 1.609H6.839m17.419-7.758H13.04a3.87 3.87 0 00-3.42 2.064L2 47h50.52a3.867 3.867 0 002.893-1.302L62 38.273H33.936l1.133-2.271a2.903 2.903 0 012.596-1.608h17.56l-4.83-3.227a3.866 3.866 0 00-2.148-.652H28.13M14.58 43.121h42.792m-53.175 0h6.511m22.259-20.363l-5.226-6.982A1.934 1.934 0 0026.194 15h-1.936l2.903 7.758",
    stroke: "#D4A459",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgMotorYacht;